<template>
    <div class="col-md-12 col-lg-12 mobile_pr_15 split-shipment-address-manager">
        <div class="white_box">
            <h1 class="heading1">2. Shipping Details</h1>
            <div class="shipping-options-section mb-4">
                <div class="shipping-options-radio-group">
                    <label class="shipping-option-label">
                        <input type="radio" value="ship_to_address" v-model="shipping_option" />
                        <span class="radio-text">Ship To an Address</span>
                    </label>
                    <label class="shipping-option-label">
                        <input type="radio" value="multiple" v-model="shipping_option" />
                        <span class="radio-text">Ship to multiple Addresses</span>
                    </label>
                    <label class="shipping-option-label">
                        <input type="radio" value="pickup_warehouse" v-model="shipping_option" />
                        <span class="radio-text">Pickup at warehouse</span>
                    </label>
                    <label class="shipping-option-label">
                        <input type="radio" value="delivery" v-model="shipping_option" />
                        <span class="radio-text">Delivery</span>
                    </label>
                </div>
            </div>
            <!-- Bulk Address Upload Section -->
            <div class="bulk-upload-section mb-4">
                <div class="add_address_section_wrapper">
                    <div class="add_address_section">
                        <h2 class="heading2">Add Addresses </h2>
                        <p class="mb-4 text-muted">
                            You can add addresses individually or use the bulk upload option.
                        </p>
            
                    </div>
                    <div class="add_address_section_buttons">
                        <!-- <a 
                            href="#" 
                            class="bulk-upload-link text_primary_blue"
                            @click.prevent="downloadSampleCSV"
                        >
                           <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.91667 7.30133L2.55733 4.94267L3.02933 4.46267L4.58333 6.01667V0.25H5.25V6.01667L6.80333 4.46333L7.276 4.94267L4.91667 7.30133ZM0.25 9.58333V6.89133H0.916667V8.91667H8.91667V6.89133H9.58333V9.58333H0.25Z" fill="#1D6CB5" stroke="#1D6CB5" stroke-width="0.5"/>
</svg>
                            Download CSV Sample
                        </a> -->
                        <a 
                            href="#" 
                            class="bulk-upload-link text_primary_blue"
                            @click.prevent="triggerFileUpload"
                        >
                           <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.91667 7.30133L2.55733 4.94267L3.02933 4.46267L4.58333 6.01667V0.25H5.25V6.01667L6.80333 4.46333L7.276 4.94267L4.91667 7.30133ZM0.25 9.58333V6.89133H0.916667V8.91667H8.91667V6.89133H9.58333V9.58333H0.25Z" fill="#1D6CB5" stroke="#1D6CB5" stroke-width="0.5"/>
</svg>
                            Bulk Addresses Upload
                        </a>
                        <div
                            class="bulk-info-popover-wrap"
                            ref="bulkInfoPopoverRoot"
                        >
                            <button
                                type="button"
                                class="bulk-info-popover-trigger"
                                :aria-expanded="bulkUploadInfoPopoverOpen ? 'true' : 'false'"
                                aria-haspopup="true"
                                aria-label="Bulk upload information"
                                @click.stop="toggleBulkUploadInfoPopover"
                            >
                                <img
                                    src="/maincss/images/info.svg"
                                    alt=""
                                    class="info-icon"
                                />
                            </button>
                            <div
                                v-show="bulkUploadInfoPopoverOpen"
                                class="bulk-info-popover"
                                role="tooltip"
                                @click.stop
                            >
                                <div
                                    class="bulk-info-popover__arrow"
                                    aria-hidden="true"
                                ></div>
                                <p class="bulk-info-popover__text">
                                    To upload multiple addresses, use the bulk
                                    upload feature. Review the sample CSV file
                                    first.
                                </p>
                                <a
                                    href="#"
                                    class="bulk-info-popover__download text_primary_blue"
                                    @click.prevent="downloadSampleCSVFromPopover"
                                >
                                    <svg
                                        width="10"
                                        height="10"
                                        viewBox="0 0 10 10"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        aria-hidden="true"
                                    >
                                        <path
                                            d="M4.91667 7.30133L2.55733 4.94267L3.02933 4.46267L4.58333 6.01667V0.25H5.25V6.01667L6.80333 4.46333L7.276 4.94267L4.91667 7.30133ZM0.25 9.58333V6.89133H0.916667V8.91667H8.91667V6.89133H9.58333V9.58333H0.25Z"
                                            fill="#1D6CB5"
                                            stroke="#1D6CB5"
                                            stroke-width="0.5"
                                        />
                                    </svg>
                                    Download CSV Sample
                                </a>
                            </div>
                        </div>
                        <input 
                            type="file" 
                            ref="csvFileInput" 
                            accept=".csv" 
                            @change="handleBulkUpload" 
                            style="display: none"
                        />
                        <button
                        type="button"
                        class="add_address"
                        @click="addNewAddress"
                    >
                        + Add Address
                    </button>
                    </div>
                   
                </div>
            </div>

            <!-- Add Address Form (at top when adding new) -->
            <div class="address-form-section mb-4" v-if="showAddressForm && editingAddressIndex === null">
                <h3>Add Address</h3>
                
                <form @submit.prevent="saveAddress" data-vv-scope="splitAddressForm">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group label-const">
                                <label >Address Title (Optional)</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="currentAddress.address_title"
                                    placeholder="Enter Address Title"
                                />
                               
                                <span class="highlight"></span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group label-const">
                                <label >Name*</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="currentAddress.fullname"
                                    name="fullname"
                                    v-validate="'required'"
                                    placeholder="Enter Full Name"
                                />
                                
                                <span class="highlight"></span>
                                <small class="form-text text-error text-left" v-show="errors.has('splitAddressForm.fullname')">
                                    {{ errors.first('splitAddressForm.fullname') }}
                                </small>
                            </div>
                        </div>
                          <div class="col-md-3">
                            <div class="form-group label-const">
                                <label >Company Name (Optional)</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="currentAddress.company_name"
                                    placeholder="Enter Company Name"
                                />
                                
                                <span class="highlight"></span>
                            </div>
                        </div>
                    </div>

                  

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group label-const">
                                <label  class="add1">Address 1*</label>
                                <textarea
                                    class="form-control"
                                    v-model="currentAddress.address_line1"
                                    name="address_line1"
                                    v-validate="'required'"
                                    placeholder="Enter Address 1"
                                    rows="2"
                                ></textarea>
                               
                                <span class="highlight"></span>
                                <small class="form-text text-error text-left" v-show="errors.has('splitAddressForm.address_line1')">
                                    {{ errors.first('splitAddressForm.address_line1') }}
                                </small>
                                <div v-if="address1_suggestion" class="address-suggestion mt-2">
                                    <small class="text-info">
                                        <strong>Suggested Address 1:</strong> {{ address1_suggestion }}
                                        <button type="button" class="btn btn-sm btn-link p-0 ml-2" @click="applyAddress1Suggestion">
                                            Use this
                                        </button>
                                    </small>
                                </div>
                            </div>
                        </div>
                            <div class="col-md-6">
                                <div class="form-group label-const">
                                    <label  class="add1">Address 2</label>
                                    <textarea
                                        class="form-control"
                                        v-model="currentAddress.address_line2"
                                        placeholder="Enter Address 2"
                                        rows="2"
                                    ></textarea>
                                
                                    <span class="highlight"></span>
                                    <div v-if="address2_suggestion" class="address-suggestion mt-2">
                                        <small class="text-info">
                                            <strong>Suggested Address 2:</strong> {{ address2_suggestion }}
                                            <button type="button" class="btn btn-sm btn-link p-0 ml-2" @click="applyAddress2Suggestion">
                                                Use this
                                            </button>
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>

                 

                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group label-const">
                                <label >City*</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="currentAddress.city"
                                    name="city"
                                    v-validate="'required'"
                                    placeholder="Enter City"
                                />
                                
                                <span class="highlight"></span>
                                <small class="form-text text-error text-left" v-show="errors.has('splitAddressForm.city')">
                                    {{ errors.first('splitAddressForm.city') }}
                                </small>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="select_option_label bill_state">State*</label>
                                <v-select
                                    v-if="reloadStateInput"
                                    autocomplete="off"
                                    label="code"
                                    :reduce="(name) => name.code"
                                    :options="all_states"
                                    placeholder="Select State"
                                    name="state"
                                    v-model="currentAddress.state"
                                    v-validate="'required'"
                                    :clearable="true"
                                ></v-select>
                                <small class="form-text text-error text-left" v-show="errors.has('splitAddressForm.state')">
                                    {{ errors.first('splitAddressForm.state') }}
                                </small>
                                <small class="form-text text-error text-left font-weight-bold" v-if="state_suggestion">
                                    Suggestion: {{ state_suggestion }}
                                </small>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group label-const">
                                <label >Zip*</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="currentAddress.zip"
                                    name="zip"
                                    v-validate="'required'"
                                    placeholder="Enter Zip Code"
                                />
                               
                                <span class="highlight"></span>
                                <small class="form-text text-error text-left" v-show="errors.has('splitAddressForm.zip')">
                                    {{ errors.first('splitAddressForm.zip') }}
                                </small>
                            </div>
                        </div>
                         <div class="col-md-3">
                            <div class="form-group">
                                <label class="select_option_label">Country</label>
                                <v-select
                                    v-if="reloadCountryInput"
                                    autocomplete="off"
                                    label="name"
                                    :reduce="(country) => country.code"
                                    :options="all_countries"
                                    placeholder="Select Country"
                                    name="Country"
                                    v-model="currentAddress.country"
                                    :clearable="true"
                                ></v-select>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                       
                          <div class="col-md-3">
                            <div class="form-group label-const">
                                <label >Phone No</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="currentAddress.phone"
                                    placeholder="Enter Phone Number"
                                />
                                
                                <span class="highlight"></span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group label-const">
                                <label >Email*</label>
                                <input
                                    type="email"
                                    class="form-control"
                                    v-model="currentAddress.email"
                                    name="email"
                                    v-validate="'required|email'"
                                    placeholder="Enter Email"
                                />
                                <span class="highlight"></span>
                                <small class="form-text text-error text-left" v-show="errors.has('splitAddressForm.email')">
                                    {{ errors.first('splitAddressForm.email') }}
                                </small>
                            </div>
                        </div>
                    </div>

                    <div class="form-actions mt-4 d-flex justify-content-between align-items-center add-address-btns">
                        <button
                            type="button"
                            class="btn btn_outline_primary border_primary_blue"
                            @click="cancelEdit"
                        >
                            CANCEL
                        </button>
                        <button
                            type="submit"
                            class="btn btn_orange bg_primary_orange text_white address-form-save-btn save-width"
                            :disabled="isSaving"
                        >
                            SAVE
                        </button>
                    </div>
                </form>
            </div>

            <!-- Existing Addresses List (with Edit form below the address being edited) -->
            <div class="addresses-list mb-4" v-if="splitAddresses.length > 0">
                <div 
                    v-for="(address, index) in orderedSplitAddresses" 
                    :key="address.id || address._originalIndex || index"
                    class="address-item"
                >
                    <div class="d-flex justify-content-between align-items-start">
                        <div class="address-details flex-grow-1">
                            <div class="address_info">
                                <p class="mr-2">Address {{ index + 1 }}:</p>
                                <div class="address-text">
                                <span v-if="address.address_title">{{ address.address_title }}, </span>
                                <span v-if="address.company_name">{{ address.company_name }}, </span>
                                <span v-if="address.fullname || (address.first_name && address.last_name)">
                                    {{ address.fullname || (address.first_name + ' ' + address.last_name) }}, 
                                </span>
                                <span v-if="address.address_line1">{{ address.address_line1 }}, </span>
                                <span v-if="address.city">{{ address.city }}, </span>
                                <span v-if="address.state">{{ address.state }} </span>
                                <span v-if="address.zip">{{ address.zip }}</span>
                            </div>
                            </div>
                        </div>
                        <div class="address-actions">
                             <span v-if="address.is_default" class="badge-primary">Default Address</span>
                                <label v-else class="checkbox_custom mb-0">
                                    <span class="set-default-text">Set as Default</span>
                                    <input
                                        type="radio"
                                        :name="'default_address'"
                                        :value="address._originalIndex"
                                        :checked="false"
                                        @change="setDefaultAddress(address._originalIndex)"
                                    />
                                    <span class="checkmark radio-mark"></span>
                                    
                                </label>
                            <button 
                                class="edit_icon"
                                @click="editAddress(address._originalIndex)"
                            >
                                <img src="/maincss/images/icons/new-edit.svg" alt="edit" class="mr-1" style="width: 14px; height: 14px;" />
                              
                            </button>
                        </div>
                    </div>
                    <!-- Edit Address Form (below this address when editing) -->
                    <div class="address-form-section mt-3 mb-4" v-if="showAddressForm && editingAddressIndex === index">
                        <h3>Edit Address</h3>
                        <form @submit.prevent="saveAddress" data-vv-scope="splitAddressForm">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group label-const">
                                        <label >Address Title (Optional)</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="currentAddress.address_title"
                                            placeholder="Enter Address Title"
                                        />
                                        <span class="highlight"></span>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group label-const">
                                        <label >Name*</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="currentAddress.fullname"
                                            name="fullname"
                                            v-validate="'required'"
                                            placeholder="Enter Full Name"
                                        />
                                        <span class="highlight"></span>
                                        <small class="form-text text-error text-left" v-show="errors.has('splitAddressForm.fullname')">
                                            {{ errors.first('splitAddressForm.fullname') }}
                                        </small>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group label-const">
                                        <label >Company Name (Optional)</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="currentAddress.company_name"
                                            placeholder="Enter Company Name"
                                        />
                                        <span class="highlight"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group label-const">
                                        <label  class="add1">Address 1*</label>
                                        <textarea
                                            class="form-control"
                                            v-model="currentAddress.address_line1"
                                            name="address_line1"
                                            v-validate="'required'"
                                            placeholder="Enter Address 1"
                                            rows="2"
                                        ></textarea>
                                        <span class="highlight"></span>
                                        <small class="form-text text-error text-left" v-show="errors.has('splitAddressForm.address_line1')">
                                            {{ errors.first('splitAddressForm.address_line1') }}
                                        </small>
                                        <div v-if="address1_suggestion" class="address-suggestion mt-2">
                                            <small class="text-info">
                                                <strong>Suggested Address 1:</strong> {{ address1_suggestion }}
                                                <button type="button" class="btn btn-sm btn-link p-0 ml-2" @click="applyAddress1Suggestion">Use this</button>
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group label-const">
                                        <label  class="add1">Address 2</label>
                                        <textarea
                                            class="form-control"
                                            v-model="currentAddress.address_line2"
                                            placeholder="Enter Address 2"
                                            rows="2"
                                        ></textarea>
                                        <span class="highlight"></span>
                                        <div v-if="address2_suggestion" class="address-suggestion mt-2">
                                            <small class="text-info">
                                                <strong>Suggested Address 2:</strong> {{ address2_suggestion }}
                                                <button type="button" class="btn btn-sm btn-link p-0 ml-2" @click="applyAddress2Suggestion">Use this</button>
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group label-const">
                                        <label >City*</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="currentAddress.city"
                                            name="city"
                                            v-validate="'required'"
                                            placeholder="Enter City"
                                        />
                                        <span class="highlight"></span>
                                        <small class="form-text text-error text-left" v-show="errors.has('splitAddressForm.city')">
                                            {{ errors.first('splitAddressForm.city') }}
                                        </small>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="select_option_label bill_state">State*</label>
                                        <v-select
                                            v-if="reloadStateInput"
                                            autocomplete="off"
                                            label="code"
                                            :reduce="(name) => name.code"
                                            :options="all_states"
                                            placeholder="Select State"
                                            name="state"
                                            v-model="currentAddress.state"
                                            v-validate="'required'"
                                            :clearable="true"
                                        ></v-select>
                                        <small class="form-text text-error text-left" v-show="errors.has('splitAddressForm.state')">
                                            {{ errors.first('splitAddressForm.state') }}
                                        </small>
                                        <small class="form-text text-error text-left font-weight-bold" v-if="state_suggestion">
                                            Suggestion: {{ state_suggestion }}
                                        </small>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group label-const">
                                        <label >Zip*</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="currentAddress.zip"
                                            name="zip"
                                            v-validate="'required'"
                                            placeholder="Enter Zip Code"
                                        />
                                        <span class="highlight"></span>
                                        <small class="form-text text-error text-left" v-show="errors.has('splitAddressForm.zip')">
                                            {{ errors.first('splitAddressForm.zip') }}
                                        </small>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="select_option_label">Country</label>
                                        <v-select
                                            v-if="reloadCountryInput"
                                            autocomplete="off"
                                            label="name"
                                            :reduce="(country) => country.code"
                                            :options="all_countries"
                                            placeholder="Select Country"
                                            name="Country"
                                            v-model="currentAddress.country"
                                            :clearable="true"
                                        ></v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group label-const">
                                        <label >Phone No</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="currentAddress.phone"
                                            placeholder="Enter Phone Number"
                                        />
                                        <span class="highlight"></span>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group label-const">
                                        <label >Email*</label>
                                        <input
                                            type="email"
                                            class="form-control"
                                            v-model="currentAddress.email"
                                            name="email"
                                            v-validate="'required|email'"
                                            placeholder="Enter Email"
                                        />
                                        <span class="highlight"></span>
                                        <small class="form-text text-error text-left" v-show="errors.has('splitAddressForm.email')">
                                            {{ errors.first('splitAddressForm.email') }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="form-actions mt-4 d-flex justify-content-between align-items-center add-address-btns">
                                <button
                                    type="button"
                                    class="btn btn_outline_primary border_primary_blue"
                                    @click="cancelEdit"
                                >
                                    CANCEL
                                </button>
                                <button
                                    type="submit"
                                    class="btn btn_orange bg_primary_orange text_white address-form-save-btn save-width"
                                    :disabled="isSaving"
                                >
                                    SAVE
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div v-else class="text-center mt-4">
                <p class="text-muted">No address available.</p>
            </div>
        </div>
        
        <!-- Preloader - same as used throughout the website -->
        <div class="preloader" v-show="isSaving || isBulkImporting">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>

        <!-- Address Import Errors Modal -->
        <div
            class="modal fade text-left"
            id="uploadAddressCSVErrors"
            tabindex="-1"
            role="dialog"
            aria-labelledby="uploadAddressCSVErrorsLabel"
            aria-hidden="true"
            data-backdrop="static"
            data-keyboard="false"
        >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="uploadAddressCSVErrorsLabel">
                            Import Addresses Errors Log
                        </h4>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <i class="ft ft-x font-large-1"></i>
                        </button>
                    </div>
                    <div
                        class="modal-body"
                        style="
                            max-height: 500px;
                            overflow-y: auto;
                            padding-top: 10px;
                        "
                    >
                        <p class="text-success text-uppercase" v-if="bulkImportSuccessMessage">
                            {{ bulkImportSuccessMessage }}
                        </p>
                        <p class="text-warning font-medium-3" v-if="bulkImportErrors.length > 0">
                            Please correct below data in CSV:
                        </p>
                        <table class="table table-hover" v-if="bulkImportErrors.length > 0">
                            <thead>
                                <tr>
                                    <th>Row</th>
                                    <th>Address</th>
                                    <th>Error Logs</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(error, index) in bulkImportErrors"
                                    :key="index"
                                >
                                    <td>Row {{ error.row }}</td>
                                    <td>{{ error.address || 'N/A' }}</td>
                                    <td>{{ error.error }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-outline-primary"
                            data-dismiss="modal"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="disclaimer">
            <p class="text-muted small">
                Disclaimer: Final Kitting Costs May Be More Or Less Than Shown, This Amount Should Be Considered An Estimate. Shipping Costs Can Vary Significantly Based On Location.
            </p>
        </div>
    </div>
</template>

<script>
import ApiService from "@/common/api.service";

export default {
    name: "SplitShipmentAddressManager",
    data() {
        return {
            shipping_option: 'multiple',
            splitAddresses: [],
            currentAddress: {
                address_title: "",
                fullname: "",
                company_name: "",
                phone: "",
                email: "",
                address_line1: "",
                address_line2: "",
                city: "",
                state: "",
                zip: "",
                country: "US",
                is_default: false
            },
            editingAddressIndex: null,
            showAddressForm: false,
            all_states: [],
            all_countries: [],
            reloadStateInput: true,
            reloadCountryInput: true,
            address1_suggestion: "",
            address2_suggestion: "",
            state_suggestion: "",
            bulkImportErrors: [],
            bulkImportSuccessMessage: "",
            isSaving: false,
            isBulkImporting: false,
            bulkUploadInfoPopoverOpen: false,
            /** Filled from GET /user-profile — used to prefill Add Address in split flow */
            customerProfileDefaults: null
        };
    },
    computed: {
        orderedSplitAddresses() {
            const addresses = Array.isArray(this.splitAddresses) ? this.splitAddresses : [];
            return addresses
                .map((address, index) => ({ ...address, _originalIndex: index }));
        }
    },
    mounted() {
        this.getStates();
        this.getCountries();
        this.loadExistingAddresses();
        this.loadCustomerProfileDefaults();
        // Ensure form is reset on mount
        this.resetForm();
        this.$validator.localize('en', {
      custom: {
        fullname: {
          required: 'The Full name is required'
        },
        address_line1: {
          required: 'The Address 1 is required'
        },
        city: {
          required: 'The City is required'
        },
        state: {
          required: 'Please select a state'
        },
        zip: {
          required: 'The Zip code is required'
        },
        email: {
          required: 'Email is required',
          email: 'Enter a valid email address'
        }
      }
    });
    },
    beforeDestroy() {
        document.removeEventListener("click", this.closeBulkUploadInfoOnOutsideClick);
    },
    watch: {
        shipping_option(newVal) {
        if (newVal === 'multiple') {
            return;
        } else {
            this.$emit('exit-split-shipment', {
                selectedOption: newVal
            });
        }
    }
},
    methods: {
        capitalize(value) {
            if (!value) return "";
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        formatProfilePhone(user) {
            if (!user) return "";
            let phone = user.mobile ? user.mobile : "";
            if (user.Profile && user.Profile.phone_no) {
                phone = user.Profile.phone_no;
            }
            const x = String(phone || "")
                .replace(/\D/g, "")
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            if (!x) return "";
            return !x[2]
                ? x[1] || ""
                : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
        },
        buildCustomerDefaultsFromUser(user) {
            if (!user) return null;
            return {
                firstName: this.capitalize(user.first_name || ""),
                lastName: this.capitalize(user.last_name || ""),
                email: user.email || "",
                phone: this.formatProfilePhone(user)
            };
        },
        loadCustomerProfileDefaults() {
            ApiService.get("/user-profile")
                .then(({ data }) => {
                    const user = data && data.user;
                    if (!user) return;
                    this.customerProfileDefaults = this.buildCustomerDefaultsFromUser(user);
                    if (this.showAddressForm && this.editingAddressIndex === null) {
                        this.applyCustomerDefaultsToSplitAddressForm();
                    }
                })
                .catch(() => {
                    /* leave null; apply still uses Vuex user if present */
                });
        },
        /**
         * Prefill Name / Email / Phone for new split addresses only (not when editing).
         * Uses parent Checkout order_data when set, else /user-profile, else Vuex currentUserClient.
         */
        applyCustomerDefaultsToSplitAddressForm() {
            if (this.editingAddressIndex !== null) {
                return;
            }
            const pod = this.$parent && this.$parent.order_data;
            const def =
                this.customerProfileDefaults ||
                this.buildCustomerDefaultsFromUser(
                    this.$store.getters.currentUserClient
                ) ||
                {};
            const fn = (
                (pod && pod.firstName) ||
                def.firstName ||
                ""
            )
                .toString()
                .trim();
            const ln = (
                (pod && pod.lastName) ||
                def.lastName ||
                ""
            )
                .toString()
                .trim();
            if (!(this.currentAddress.fullname || "").trim()) {
                if (fn || ln) {
                    this.currentAddress.fullname = [fn, ln]
                        .filter(Boolean)
                        .join(" ");
                } else if (pod && pod.fullname) {
                    this.currentAddress.fullname = pod.fullname;
                }
            }
            if (!(this.currentAddress.email || "").trim()) {
                const email = (pod && pod.email) || def.email || "";
                if (email) {
                    this.currentAddress.email = email;
                }
            }
            if (!(this.currentAddress.phone || "").trim()) {
                const phone = (pod && pod.phone) || def.phone || "";
                if (phone) {
                    this.currentAddress.phone = phone;
                }
            }
            if (!this.currentAddress.country) {
                this.currentAddress.country = "US";
            }
        },
        loadExistingAddresses() {
            // Load addresses from Vuex store if available
            if (this.$store.state.splitShipment && this.$store.state.splitShipment.splitAddresses && this.$store.state.splitShipment.splitAddresses.length > 0) {
                this.splitAddresses = [...this.$store.state.splitShipment.splitAddresses];
                // Ensure only one address is default
                this.ensureOnlyOneDefault();
            } else {
                // Load from API
                this.getAddresses();
            }
        },
        getAddresses() {
            var _this = this;
            return new Promise((resolve, reject) => {
                ApiService.get("/addresses")
                    .then(({ data }) => {
                        var addresses = [];
                        var foundDefault = false;
                        if (data.address && data.address.length > 0) {
                            data.address.forEach((elem) => {
                                // Ensure country is uppercase two-letter code
                                let countryCode = (elem.country || "US").toString().toUpperCase().substring(0, 2);
                                
                                // Only set first address with "Default Shipping Address" as default
                                // If multiple exist, only the first one will be default
                                var isDefault = false;
                                if (elem.address_type === "Default Shipping Address" && !foundDefault) {
                                    isDefault = true;
                                    foundDefault = true;
                                }
                                
                                addresses.push({
                                    id: elem.id,
                                    address_title: elem.address_title || "",
                                    fullname: (elem.first_name || "") + " " + (elem.last_name || ""),
                                    first_name: elem.first_name,
                                    last_name: elem.last_name,
                                    company_name: elem.address_label || "",
                                    phone: elem.phone || "",
                                    email: elem.email || "",
                                    address_line1: elem.address1 || "",
                                    address_line2: elem.address2 || "",
                                    city: elem.city || "",
                                    state: elem.state || "",
                                    zip: elem.pincode || "",
                                    country: countryCode, // Always two-letter uppercase code
                                    is_default: isDefault
                                });
                            });
                        }
                        _this.splitAddresses = addresses;
                        // Save addresses to Vuex store
                        _this.$store.commit("splitShipment/setSplitAddresses", addresses);
                        // console.log("[SplitShipmentAddressManager] getAddresses - Saved addresses to Vuex:", addresses.length);
                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        reject(err);
                    });
            });
        },
        getStates() {
            var _this = this;
            ApiService.get("/states")
                .then(({ data }) => {
                    _this.all_states = data.states || [];
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getCountries() {
            var _this = this;
            ApiService.get("/countries")
                .then(({ data }) => {
                    _this.all_countries = data.countries || [];
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async verifyAddressWithUSPS(address) {
            const params = {
                address1: address.address_line1 || address.address1 || "",
                address2: address.address_line2 || address.address2 || "",
                city: address.city || "",
                addressstate: address.state || "",
                addresszip: address.zip || address.pincode || ""
            };
            
            // Log for debugging
            console.log("[SplitShipmentAddressManager] verifyAddressWithUSPS - Input address:", address);
            console.log("[SplitShipmentAddressManager] verifyAddressWithUSPS - Params:", params);
            
            // Validate required fields
            if (!params.address1 || !params.addressstate || !params.addresszip) {
                const errorMsg = "Address 1, State, and Zip are required for address verification";
                console.error("[SplitShipmentAddressManager] Missing required fields:", params);
                this.$toast.error(errorMsg, {
                    position: "top-right",
                    queue: true,
                    duration: 5000
                });
                return Promise.reject({ success: false, error: errorMsg });
            }
            
            this.resetSuggestions();
            return new Promise((resolve, reject) => {
                ApiService.post("/verifyAddress/usps", params)
                    .then(({ data }) => {
                        console.log("[SplitShipmentAddressManager] USPS API Response:", data);
                        // Check for error response first
                        if (!data.success) {
                            const errorMessage = data.error || "Address validation failed";
                            console.error("USPS Address Validation Error:", errorMessage);
                            this.$toast.error(errorMessage, {
                                position: "top-right",
                                queue: true,
                                duration: 5000
                            });
                            reject({ success: false, error: errorMessage });
                            return;
                        }

                        // Handle new USPS Addresses 3.0 API response structure
                        if (!data.result) {
                            console.error("USPS Address Validation Error: No result in response", data);
                            this.$toast.error("Invalid response from address validation service", {
                                position: "top-right",
                                queue: true,
                                duration: 5000
                            });
                            reject({ success: false, error: "Invalid response from address validation service" });
                            return;
                        }

                        const result = data.result;
                        const addressData = result.address || {};
                        const additionalInfo = result.additionalInfo || {};

                        // Check DPVConfirmation - valid values are "Y" (Confirmed), "S" (Secondary confirmed), "D" (Default confirmed)
                        // "N" (Not confirmed) is invalid
                        const validDPVConfirmations = ["Y", "S", "D"];
                        if (!validDPVConfirmations.includes(additionalInfo.DPVConfirmation)) {
                            console.error("USPS Address Validation Error: DPVConfirmation is not valid", additionalInfo);
                            // Set field-specific error
                            if (this.$validator) {
                                this.$validator.errors.add({
                                    field: 'splitAddressForm.zip',
                                    msg: 'Invalid ZIP Code. Please enter a valid zip code.'
                                });
                            }
                            this.$toast.error("Invalid ZIP Code", {
                                position: "top-right",
                                queue: true,
                                duration: 5000
                            });
                            reject({ success: false, error: "Invalid ZIP Code", field: 'zip' });
                            return;
                        }

                        // Check if address is vacant
                        if (additionalInfo.vacant === "Y") {
                            this.$toast.warning("This address is marked as vacant", {
                                position: "top-right",
                                queue: true
                            });
                        }

                        // Show warnings if any
                        if (result.warnings && result.warnings.length > 0) {
                            result.warnings.forEach(warning => {
                                this.$toast.warning(warning.message || "Address validation warning", {
                                    position: "top-right",
                                    queue: true
                                });
                            });
                        }

                        // Validate ZIP code first - if ZIP is wrong, reject and show error on field
                        const addressZip = address.zip || address.pincode || "";
                        if (addressData.ZIPCode && addressZip != addressData.ZIPCode) {
                            // Set field-specific error
                            if (this.$validator) {
                                this.$validator.errors.add({
                                    field: 'splitAddressForm.zip',
                                    msg: 'Invalid Zip / PostalCode. Please enter a valid zip code.'
                                });
                            }
                            this.$toast.error("Invalid Zip / PostalCode", {
                                position: "top-right",
                                queue: true
                            });
                            reject({ success: false, error: "Invalid Zip / PostalCode", field: 'zip' });
                            return;
                        }

                        // Validate state - if state is wrong, reject and show error on field
                        const addressState = address.state || "";
                        if (addressData.state && addressState != addressData.state) {
                            this.state_suggestion = addressData.state;
                            // Set field-specific error
                            if (this.$validator) {
                                this.$validator.errors.add({
                                    field: 'splitAddressForm.state',
                                    msg: 'Invalid State. Please select a valid state.'
                                });
                            }
                            this.$toast.error("Invalid State", {
                                position: "top-right",
                                queue: true
                            });
                            reject({ success: false, error: "Invalid State", field: 'state' });
                            return;
                        }

                        // Validate city - if city is wrong, reject and show error on field
                        const addressCity = address.city || "";
                        if (addressData.city && addressCity.toLowerCase() != addressData.city.toLowerCase()) {
                            // Set field-specific error
                            if (this.$validator) {
                                this.$validator.errors.add({
                                    field: 'splitAddressForm.city',
                                    msg: 'Invalid City. Please enter a valid city name.'
                                });
                            }
                            this.$toast.error("Invalid City", {
                                position: "top-right",
                                queue: true
                            });
                            reject({ success: false, error: "Invalid City", field: 'city' });
                            return;
                        }

                        // If ZIP code is correct but address1 doesn't match, show correction (not error)
                        const addressLine1 = address.address_line1 || address.address1 || "";
                        if (addressData.streetAddress && addressLine1.toLowerCase() != addressData.streetAddress.toLowerCase()) {
                            this.address1_suggestion = addressData.streetAddress;
                            this.$toast.info(`Address correction: ${addressData.streetAddress}`, {
                                position: "top-right",
                                queue: true,
                                duration: 5000
                            });
                            // Don't reject - allow address to be saved with correction suggestion
                        }

                        // Validate Address 2 (secondaryAddress) - show correction only if content is different and meaningful
                        const addressLine2 = address.address_line2 || address.address2 || "";
                        if (addressData.secondaryAddress && addressLine2 && addressLine2.trim()) {
                            // Normalize both for comparison (trim and lowercase)
                            const userAddress2 = addressLine2.trim().toLowerCase();
                            const uspsAddress2 = addressData.secondaryAddress.trim().toLowerCase();
                            
                            // Only show suggestion if content is actually different (case-insensitive comparison)
                            // And if USPS suggestion is meaningful (not just "# R" or very short ambiguous values)
                            if (userAddress2 !== uspsAddress2) {
                                // Filter out ambiguous or very short suggestions like "# R", "#", etc.
                                const uspsTrimmed = addressData.secondaryAddress.trim();
                                const isMeaningfulSuggestion = uspsTrimmed.length > 2 && 
                                    !(/^#\s*[A-Z]$/i.test(uspsTrimmed)); // Don't show suggestions like "# R", "# A", etc.
                                
                                if (isMeaningfulSuggestion) {
                                    this.address2_suggestion = addressData.secondaryAddress;
                                    this.$toast.info(`Address 2 correction: ${addressData.secondaryAddress}`, {
                                        position: "top-right",
                                        queue: true,
                                        duration: 5000
                                    });
                                    // Don't reject - allow address to be saved with correction suggestion
                                }
                            }
                        }

                        // If address1 or address2 has a suggestion, don't proceed with save - keep form open
                        if (this.address1_suggestion || this.address2_suggestion) {
                            resolve({ success: true, hasSuggestions: true });
                            return;
                        }

                        // Address verified successfully
                        resolve({ success: true, hasSuggestions: false });
                    })
                    .catch((err) => {
                        console.error("[SplitShipmentAddressManager] USPS Address Validation Error:", err);
                        console.error("[SplitShipmentAddressManager] Error response:", err.response);
                        const errorMessage = (err.response && err.response.data && err.response.data.error) || err.error || err.message || "Address validation failed";
                        this.$toast.error(errorMessage, {
                            position: "top-right",
                            queue: true,
                            duration: 5000
                        });
                        reject({ success: false, error: errorMessage });
                    });
            });
        },
        resetSuggestions() {
            this.address1_suggestion = "";
            this.address2_suggestion = "";
            this.state_suggestion = "";
        },
        async verifyAddressForBulkImport(address) {
            // Similar to verifyAddressWithUSPS but without toast notifications for bulk import
            const params = {
                address1: address.address_line1 || address.address1 || "",
                address2: address.address_line2 || address.address2 || "",
                city: address.city || "",
                addressstate: address.state || "",
                addresszip: address.zip || address.pincode || ""
            };
            return new Promise((resolve, reject) => {
                ApiService.post("/verifyAddress/usps", params)
                    .then(({ data }) => {
                        if (!data.success) {
                            const errorMessage = data.error || "Address validation failed";
                            reject({ success: false, error: errorMessage });
                            return;
                        }

                        if (!data.result) {
                            reject({ success: false, error: "Invalid response from address validation service" });
                            return;
                        }

                        const result = data.result;
                        const addressData = result.address || {};
                        const additionalInfo = result.additionalInfo || {};

                        const validDPVConfirmations = ["Y", "S", "D"];
                        if (!validDPVConfirmations.includes(additionalInfo.DPVConfirmation)) {
                            reject({ success: false, error: "Invalid ZIP Code" });
                            return;
                        }

                        // Validate ZIP code
                        const addressZip = address.zip || address.pincode || "";
                        if (addressData.ZIPCode && addressZip != addressData.ZIPCode) {
                            reject({ success: false, error: "Invalid Zip / PostalCode" });
                            return;
                        }

                        // Validate state
                        const addressState = address.state || "";
                        if (addressData.state && addressState != addressData.state) {
                            reject({ success: false, error: "Invalid State" });
                            return;
                        }

                        // Validate city
                        const addressCity = address.city || "";
                        if (addressData.city && addressCity.toLowerCase() != addressData.city.toLowerCase()) {
                            reject({ success: false, error: "Invalid City" });
                            return;
                        }

                        // Check for suggestions (but don't reject)
                        let hasSuggestions = false;
                        if (addressData.streetAddress && address.address_line1.toLowerCase() != addressData.streetAddress.toLowerCase()) {
                            hasSuggestions = true;
                        }
                        if (addressData.secondaryAddress && address.address_line2 && address.address_line2.trim()) {
                            const userAddress2 = address.address_line2.trim().toLowerCase();
                            const uspsAddress2 = addressData.secondaryAddress.trim().toLowerCase();
                            if (userAddress2 !== uspsAddress2) {
                                const uspsTrimmed = addressData.secondaryAddress.trim();
                                const isMeaningfulSuggestion = uspsTrimmed.length > 2 && 
                                    !(/^#\s*[A-Z]$/i.test(uspsTrimmed));
                                if (isMeaningfulSuggestion) {
                                    hasSuggestions = true;
                                }
                            }
                        }

                        resolve({ success: true, hasSuggestions });
                    })
                    .catch((err) => {
                        const errorMessage = (err.response && err.response.data && err.response.data.error) || err.error || "Address validation failed";
                        reject({ success: false, error: errorMessage });
                    });
            });
        },
        saveAddress() {
            console.log('[SplitShipmentAddressManager] saveAddress called');
            
            // Prevent multiple submissions
            if (this.isSaving) {
                console.log('[SplitShipmentAddressManager] Already saving, ignoring click');
                return;
            }
            
            // Set loading state FIRST - before any checks
            // This ensures loader shows immediately when button is clicked
            this.isSaving = true;
            console.log('[SplitShipmentAddressManager] isSaving set to true');
            
            // Force Vue to update the DOM
            this.$nextTick(() => {
                console.log('[SplitShipmentAddressManager] DOM updated, isSaving:', this.isSaving);
            });
            
            // Only validate if form is visible
            if (!this.showAddressForm) {
                console.warn('[SplitShipmentAddressManager] Form not visible, returning');
                this.isSaving = false;
                return;
            }
            
            // Check if validator and fields exist before validating
            if (!this.$validator) {
                console.warn('[SplitShipmentAddressManager] Validator not available');
                this.isSaving = false;
                return;
            }
            
            if (!this.$validator.fields) {
                console.warn('[SplitShipmentAddressManager] Validator fields not ready');
                this.isSaving = false;
                return;
            }
            
            // Check if fields in scope exist
            const scopeFields = Object.keys(this.$validator.fields).filter(field => {
                return field.startsWith('splitAddressForm.');
            });
            
            console.log('[SplitShipmentAddressManager] Scope fields found:', scopeFields.length);
            
            if (scopeFields.length === 0) {
                console.warn('[SplitShipmentAddressManager] No fields found in splitAddressForm scope, but proceeding anyway');
                // Don't return - try to proceed anyway, validation might still work
            }
            
            // Wrap validateAll in try-catch to handle validation errors gracefully
            const _this = this;
            let validationPromise;
            try {
                console.log('[SplitShipmentAddressManager] Starting validation...');
                validationPromise = this.$validator.validateAll("splitAddressForm");
            } catch (err) {
                console.error('[SplitShipmentAddressManager] Error starting validation:', err);
                // Try to proceed anyway - maybe validation isn't critical
                validationPromise = Promise.resolve(true);
            }
            
            validationPromise.then(async (isValid) => {
                console.log('[SplitShipmentAddressManager] Validation result:', isValid);
                
                // Double-check form is still visible before proceeding
                if (!_this.showAddressForm) {
                    console.warn('[SplitShipmentAddressManager] Form hidden during validation');
                    _this.isSaving = false;
                    return;
                }
                
                if (!isValid) {
                    // Show validation errors
                    console.warn('[SplitShipmentAddressManager] Validation failed');
                    _this.isSaving = false;
                    _this.$toast.error("Please fill all required fields correctly", {
                        position: "top-right"
                    });
                    return;
                }

                // Email is mandatory for split shipment addresses
                const email = (_this.currentAddress.email || "").toString().trim();
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!email) {
                    _this.isSaving = false;
                    _this.$toast.error("Email is required", {
                        position: "top-right"
                    });
                    return;
                }
                if (!emailRegex.test(email)) {
                    _this.isSaving = false;
                    _this.$toast.error("Please enter a valid email address", {
                        position: "top-right"
                    });
                    return;
                }
                
                console.log('[SplitShipmentAddressManager] Validation passed, proceeding with address verification...');
                
                // Verify address with USPS before saving
                try {
                    console.log('[SplitShipmentAddressManager] Calling verifyAddressWithUSPS...');
                    const verificationResult = await _this.verifyAddressWithUSPS(_this.currentAddress);
                    console.log('[SplitShipmentAddressManager] Verification result:', verificationResult);
                    if (!verificationResult.success) {
                        _this.isSaving = false;
                        return; // Error already shown in verifyAddressWithUSPS
                    }
                    
                    // Double-check form is still visible after verification
                    if (!_this.showAddressForm) {
                        _this.isSaving = false;
                        return;
                    }
                    
                    // If address1 or address2 has a suggestion, don't proceed with save - keep form open
                    if (verificationResult.hasSuggestions || _this.address1_suggestion || _this.address2_suggestion) {
                        _this.isSaving = false;
                        return; // Keep form open so user can see and apply the suggestion
                    }
                } catch (err) {
                    console.error("Address verification failed:", err);
                    _this.isSaving = false;
                    // Check if error has a specific field
                    if (err && err.field) {
                        // Field-specific error already set in verifyAddressWithUSPS
                    }
                    return; // Error already shown in verifyAddressWithUSPS
                }
                
                // Final check - form must still be visible
                if (!_this.showAddressForm) {
                    _this.isSaving = false;
                    return;
                }
                // Ensure country is uppercase two-letter code
                let countryCode = (this.currentAddress.country || 'US').toString().toUpperCase().substring(0, 2);
                
                // If setting this address as default, remove default from all others first
                if (this.currentAddress.is_default) {
                    this.splitAddresses.forEach((addr, index) => {
                        if (index !== this.editingAddressIndex) {
                            addr.is_default = false;
                        }
                    });
                }
                
                const addressData = {
                    first_name: this.currentAddress.fullname.split(' ')[0] || '',
                    last_name: this.currentAddress.fullname.split(' ').slice(1).join(' ') || '',
                    address1: this.currentAddress.address_line1,
                    address2: this.currentAddress.address_line2 || '',
                    city: this.currentAddress.city,
                    state: this.currentAddress.state,
                    country: countryCode, // Always two-letter uppercase code
                    pincode: this.currentAddress.zip,
                    phone: this.currentAddress.phone,
                    email: this.currentAddress.email || '',
                    address_label: this.currentAddress.company_name || '',
                    address_title: this.currentAddress.address_title || '',
                    address_type: this.currentAddress.is_default ? 'Default Shipping Address' : 'Additional Shipping Address'
                };

                if (this.editingAddressIndex !== null) {
                    // Update existing address
                    const existingAddress = this.splitAddresses[this.editingAddressIndex];
                    if (existingAddress.id && typeof existingAddress.id === 'number' && existingAddress.id > 1000000000000) {
                        // Temporary ID (from Date.now()), need to create new address
                        this.createAddressInBackend(addressData).then((response) => {
                            if (response && response.data && response.data.address) {
                                const updatedAddress = {
                                    ...this.currentAddress,
                                    id: response.data.address.id
                                };
                                _this.splitAddresses[_this.editingAddressIndex] = updatedAddress;
                                // Ensure only one default after update
                                _this.ensureOnlyOneDefault();
                                _this.$store.commit("splitShipment/setSplitAddresses", _this.splitAddresses);
                                
                                // Show success message
                                _this.$toast.success("Address saved successfully", {
                                    position: "top-right"
                                });
                                
                                _this.isSaving = false;
                                _this.resetForm();
                            } else {
                                // Response doesn't have expected structure
                                console.error("Unexpected response structure:", response);
                                _this.isSaving = false;
                                _this.$toast.error("Error saving address. Unexpected response.", {
                                    position: "top-right"
                                });
                            }
                        }).catch((err) => {
                            console.error("Error creating address:", err);
                            _this.isSaving = false;
                            _this.$toast.error(_this.getApiErrorMessage(err, err.error), {
                                position: "top-right"
                            });
                            // Still update locally even if API fails
                            _this.splitAddresses[_this.editingAddressIndex] = { ..._this.currentAddress };
                            // Ensure only one default after update
                            _this.ensureOnlyOneDefault();
                            _this.$store.commit("splitShipment/setSplitAddresses", _this.splitAddresses);
                            _this.resetForm();
                        });
                    } else {
                        // Real ID exists, update via API
                        addressData.address_id = existingAddress.id;
                        this.updateAddressInBackend(addressData).then((response) => {
                            // Check if response is valid
                            if (response && (response.data || response.status === 200 || response.status === 201)) {
                                _this.splitAddresses[_this.editingAddressIndex] = { ..._this.currentAddress };
                                // Ensure only one default after update
                                _this.ensureOnlyOneDefault();
                                _this.$store.commit("splitShipment/setSplitAddresses", _this.splitAddresses);
                                
                                // Show success message
                                _this.$toast.success("Address updated successfully", {
                                    position: "top-right"
                                });
                                
                                _this.isSaving = false;
                                _this.resetForm();
                            } else {
                                // Response doesn't have expected structure
                                console.error("Unexpected response structure:", response);
                                _this.isSaving = false;
                                _this.$toast.error("Error updating address. Unexpected response.", {
                                    position: "top-right"
                                });
                            }
                        }).catch((err) => {
                            console.error("Error updating address:", err);
                            _this.isSaving = false;
                            _this.$toast.error(_this.getApiErrorMessage(err, err.error), {
                                position: "top-right"
                            });
                            // Still update locally even if API fails
                            _this.splitAddresses[_this.editingAddressIndex] = { ..._this.currentAddress };
                            // Ensure only one default after update
                            _this.ensureOnlyOneDefault();
                            _this.$store.commit("splitShipment/setSplitAddresses", _this.splitAddresses);
                            _this.resetForm();
                        });
                    }
                } else {
                    // Add new address - save to backend
                    this.createAddressInBackend(addressData).then((response) => {
                        if (response && response.data && response.data.address) {
                            const newAddress = {
                                ...this.currentAddress,
                                id: response.data.address.id
                            };
                            _this.splitAddresses.push(newAddress);
                            // Ensure only one default after adding
                            _this.ensureOnlyOneDefault();
                            _this.$store.commit("splitShipment/setSplitAddresses", _this.splitAddresses);
                            
                            // Show success message
                            _this.$toast.success("Address added successfully", {
                                position: "top-right"
                            });
                            
                            _this.isSaving = false;
                            _this.resetForm();
                        } else {
                            // Response doesn't have expected structure
                            console.error("Unexpected response structure:", response);
                            _this.isSaving = false;
                            _this.$toast.error("Error adding address. Unexpected response.", {
                                position: "top-right"
                            });
                        }
                    }).catch((err) => {
                        console.error("Error creating address:", err);
                        _this.isSaving = false;
                        _this.$toast.error(_this.getApiErrorMessage(err, err.error), {
                            position: "top-right"
                        });
                        // Still add locally even if API fails
                        const newAddress = {
                            ...this.currentAddress,
                            id: Date.now() // Temporary ID
                        };
                        _this.splitAddresses.push(newAddress);
                        // Ensure only one default after adding
                        _this.ensureOnlyOneDefault();
                        _this.$store.commit("splitShipment/setSplitAddresses", _this.splitAddresses);
                        _this.resetForm();
                    });
                }
            }).catch((validationError) => {
                // Handle validation errors gracefully (e.g., fields don't exist)
                // This can happen if form is hidden during validation or fields are removed
                _this.isSaving = false;
                if (validationError && validationError.message && validationError.message.includes('non-existent field')) {
                    // Silently ignore - form was probably hidden
                    console.warn('Validation skipped - fields may have been removed');
                } else {
                    console.warn('Validation error:', validationError);
                }
                // Don't show error to user - form might have been hidden
            });
        },
        createAddressInBackend(addressData) {
            return ApiService.post("/address-book", addressData);
        },
        updateAddressInBackend(addressData) {
            return ApiService.post("/update-user-address", addressData);
        },
        getApiErrorMessage(err, fallbackMessage) {
            if (err && err.response && err.response.data) {
                const responseData = err.response.data;
                if (typeof responseData === "string" && responseData.trim()) {
                    return responseData;
                }
                if (responseData.error) {
                    return responseData.error;
                }
                if (responseData.message) {
                    return responseData.message;
                }
            }
            if (err && err.error) {
                return err.error;
            }
            if (err && err.message) {
                return err.message;
            }
            return fallbackMessage;
        },
        addNewAddress() {
            this.resetForm();
            this.showAddressForm = true;
            this.$nextTick(() => {
                this.applyCustomerDefaultsToSplitAddressForm();
            });
            // Clear errors manually instead of reset() to avoid validation
            // Wait a bit to ensure fields are fully attached
            this.$nextTick(() => {
                this.$nextTick(() => {
                    try {
                        if (this.$validator && this.$validator.errors) {
                            // Only clear errors, don't reset (which triggers validation)
                            const fieldNames = ['fullname', 'address_line1', 'city', 'state', 'zip', 'email'];
                            fieldNames.forEach(fieldName => {
                                try {
                                    const fullFieldName = `splitAddressForm.${fieldName}`;
                                    this.$validator.errors.remove(fullFieldName);
                                } catch (e) {
                                    // Ignore if field doesn't exist
                                }
                            });
                        }
                    } catch (e) {
                        // Ignore errors
                    }
                });
            });
        },
        editAddress(index) {
            this.editingAddressIndex = index;
            const addressToEdit = { ...this.splitAddresses[index] };
            // Ensure country code is set properly
            if (!addressToEdit.country) {
                addressToEdit.country = "US";
            }
            this.currentAddress = addressToEdit;
            this.showAddressForm = true;
            this.reloadStateInput = false;
            this.reloadCountryInput = false;
            this.$nextTick(() => {
                this.reloadStateInput = true;
                this.reloadCountryInput = true;
                // Clear errors manually instead of reset() to avoid validation
                // Wait a bit more to ensure fields are fully attached
                this.$nextTick(() => {
                    try {
                        if (this.$validator && this.$validator.errors) {
                            // Only clear errors, don't reset (which triggers validation)
                            const fieldNames = ['fullname', 'address_line1', 'city', 'state', 'zip', 'email'];
                            fieldNames.forEach(fieldName => {
                                try {
                                    const fullFieldName = `splitAddressForm.${fieldName}`;
                                    this.$validator.errors.remove(fullFieldName);
                                } catch (e) {
                                    // Ignore if field doesn't exist
                                }
                            });
                        }
                    } catch (e) {
                        // Ignore errors
                    }
                });
            });
        },
        deleteAddress(index) {
            if (confirm("Are you sure you want to delete this address?")) {
                this.splitAddresses.splice(index, 1);
                this.$store.commit("splitShipment/setSplitAddresses", this.splitAddresses);
                if (this.editingAddressIndex === index) {
                    this.resetForm();
                }
            }
        },
        setAsDefault() {
            if (this.currentAddress.is_default) {
                // Remove default from all other addresses
                this.splitAddresses.forEach((addr, index) => {
                    if (index !== this.editingAddressIndex) {
                        addr.is_default = false;
                    }
                });
            }
        },
        setDefaultAddress(index) {
            // Remove default from all addresses
            this.splitAddresses.forEach((addr, i) => {
                addr.is_default = (i === index);
            });
            // Ensure only one default (safety check)
            this.ensureOnlyOneDefault();
            // Save to Vuex store
            this.$store.commit("splitShipment/setSplitAddresses", this.splitAddresses);
        },
        ensureOnlyOneDefault() {
            // Find all addresses marked as default
            let defaultAddresses = this.splitAddresses.filter(addr => addr.is_default);
            
            // If more than one default exists, keep only the first one
            if (defaultAddresses.length > 1) {
                let foundFirst = false;
                this.splitAddresses.forEach((addr, index) => {
                    if (addr.is_default) {
                        if (foundFirst) {
                            // This is a duplicate default, remove it
                            addr.is_default = false;
                        } else {
                            // This is the first default, keep it
                            foundFirst = true;
                        }
                    }
                });
                // Recalculate after fixing multiple defaults
                defaultAddresses = this.splitAddresses.filter(addr => addr.is_default);
            }
            
            // If no default exists and we have addresses, set the first one as default
            if (defaultAddresses.length === 0 && this.splitAddresses.length > 0) {
                this.splitAddresses[0].is_default = true;
            }
        },
        applyAddress1Suggestion() {
            this.currentAddress.address_line1 = this.address1_suggestion;
            this.address1_suggestion = "";
        },
        applyAddress2Suggestion() {
            this.currentAddress.address_line2 = this.address2_suggestion;
            this.address2_suggestion = "";
        },
        resetForm() {
            // DON'T touch validator at all - just reset form data and hide form
            // Validator will be reset automatically when form is shown again
            this.resetSuggestions();
            this.isSaving = false; // Reset loading state
            
            this.currentAddress = {
                address_title: "",
                fullname: "",
                company_name: "",
                phone: "",
                email: "",
                address_line1: "",
                address_line2: "",
                city: "",
                state: "",
                zip: "",
                country: "US",
                is_default: false
            };
            this.editingAddressIndex = null;
            this.showAddressForm = false;
            // Force reload of v-select components to reset placeholders
            this.reloadStateInput = false;
            this.reloadCountryInput = false;
            this.$nextTick(() => {
                this.reloadStateInput = true;
                this.reloadCountryInput = true;
            });
        },
        cancelEdit() {
            this.resetForm();
        },
        triggerFileUpload() {
            this.$refs.csvFileInput.click();
        },
        toggleBulkUploadInfoPopover() {
            this.bulkUploadInfoPopoverOpen = !this.bulkUploadInfoPopoverOpen;
            if (this.bulkUploadInfoPopoverOpen) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        document.addEventListener(
                            "click",
                            this.closeBulkUploadInfoOnOutsideClick
                        );
                    }, 0);
                });
            } else {
                document.removeEventListener(
                    "click",
                    this.closeBulkUploadInfoOnOutsideClick
                );
            }
        },
        closeBulkUploadInfoOnOutsideClick(event) {
            const root = this.$refs.bulkInfoPopoverRoot;
            if (root && !root.contains(event.target)) {
                this.bulkUploadInfoPopoverOpen = false;
                document.removeEventListener(
                    "click",
                    this.closeBulkUploadInfoOnOutsideClick
                );
            }
        },
        downloadSampleCSVFromPopover() {
            this.downloadSampleCSV();
        },
        downloadSampleCSV() {
            // CSV with proper formatting - only 2 addresses as requested
            const csvContent = "Address Title,Name,Company Name,Phone,Email,Address 1,Address 2,City,State,Zip,Country\n" +
                ",John Doe,ABC Company,(805) 497-6611,john@example.com,1021 Mckeehan Rd,,Troy,ID,83871,US\n" +
                ",Jane Smith,XYZ Corp,(907) 267-1712,jane@example.com,1495 N Hickory Ave,,Meridian,ID,83642,US";
            
            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", "address_upload_sample.csv");
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        handleBulkUpload(event) {
            const file = event.target.files[0];
            if (!file) return;

            // Clear previous errors and success message
            this.bulkImportErrors = [];
            this.bulkImportSuccessMessage = "";
            
            // Show loader
            this.isBulkImporting = true;

            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const csv = e.target.result;
                    const lines = csv.split("\n");
                    const headers = lines[0].split(",").map(h => h.trim());
                    
                    const addresses = [];
                    for (let i = 1; i < lines.length; i++) {
                        if (lines[i].trim()) {
                            const values = lines[i].split(",").map(v => v.trim());
                            const address = {};
                            headers.forEach((header, index) => {
                                address[header.toLowerCase().replace(/\s+/g, "_")] = values[index] || "";
                            });
                            
                            // Ensure country is uppercase two-letter code
                            let countryCode = (address.country || "US").toString().toUpperCase().substring(0, 2);
                            
                            // Map CSV columns to address object with row number
                            addresses.push({
                                row: i + 1, // Row number in CSV (header is row 1, so data starts from row 2)
                                address_title: address.address_title || "",
                                fullname: address.name || "",
                                company_name: address.company_name || "",
                                phone: address.phone || "",
                                email: address.email || "",
                                address_line1: address.address_1 || "",
                                address_line2: address.address_2 || "",
                                city: address.city || "",
                                state: address.state || "",
                                zip: address.zip || "",
                                country: countryCode, // Always two-letter uppercase code
                                is_default: false,
                                id: Date.now() + i
                            });
                        }
                    }
                    
                    // Save each address to backend with duplicate check
                    const _this = this;
                    let savedCount = 0;
                    let updatedCount = 0;
                    let failedCount = 0;
                    
                    // First, load existing addresses to check for duplicates
                    _this.getAddresses().then(async () => {
                        const existingAddresses = _this.splitAddresses || [];
                        _this.bulkImportErrors = [];
                        _this.bulkImportSuccessMessage = "";
                        // Keep loader visible during import
                        
                        const savePromises = addresses.map(async (address) => {
                            // Email is mandatory for bulk upload addresses
                            const email = (address.email || "").toString().trim();
                            if (!email) {
                                _this.bulkImportErrors.push({
                                    row: address.row || 'N/A',
                                    address: `${address.fullname || 'N/A'}, ${address.address_line1 || 'N/A'}, ${address.city || 'N/A'}, ${address.state || 'N/A'} ${address.zip || 'N/A'}`,
                                    error: "Email is required"
                                });
                                return null;
                            }

                            // Verify address with USPS before saving
                            try {
                                const verificationResult = await _this.verifyAddressForBulkImport(address);
                                if (!verificationResult.success) {
                                    // Log error for this address with row number
                                    _this.bulkImportErrors.push({
                                        row: address.row || 'N/A',
                                        address: `${address.fullname || 'N/A'}, ${address.address_line1 || 'N/A'}, ${address.city || 'N/A'}, ${address.state || 'N/A'} ${address.zip || 'N/A'}`,
                                        error: verificationResult.error || "Address validation failed"
                                    });
                                    return null; // Skip this address
                                }
                                
                                // If address has suggestions, log warning but still proceed
                                if (verificationResult.hasSuggestions) {
                                    _this.bulkImportErrors.push({
                                        row: address.row || 'N/A',
                                        address: `${address.fullname || 'N/A'}, ${address.address_line1 || 'N/A'}, ${address.city || 'N/A'}, ${address.state || 'N/A'} ${address.zip || 'N/A'}`,
                                        error: "Address has suggestions but will be saved",
                                        warning: true
                                    });
                                }
                            } catch (err) {
                                // Log error for this address with row number
                                _this.bulkImportErrors.push({
                                    row: address.row || 'N/A',
                                    address: `${address.fullname || 'N/A'}, ${address.address_line1 || 'N/A'}, ${address.city || 'N/A'}, ${address.state || 'N/A'} ${address.zip || 'N/A'}`,
                                    error: (err.error || err.message || "Address validation failed")
                                });
                                return null; // Skip this address
                            }
                            // Ensure country is uppercase two-letter code
                            let countryCode = (address.country || 'US').toString().toUpperCase().substring(0, 2);
                            
                            const addressData = {
                                first_name: address.fullname.split(' ')[0] || '',
                                last_name: address.fullname.split(' ').slice(1).join(' ') || '',
                                address1: address.address_line1,
                                address2: address.address_line2 || '',
                                city: address.city,
                                state: address.state,
                                country: countryCode, // Always two-letter uppercase code
                                pincode: address.zip,
                                phone: address.phone || '',
                                email: address.email || '',
                                address_label: address.company_name || '',
                                address_title: address.address_title || '',
                                address_type: 'Additional Shipping Address'
                            };
                            
                            // Check if address already exists (by address1, city, state, zip, country)
                            const existingAddress = existingAddresses.find((existing) => {
                                return existing.address_line1 && existing.address_line1.toLowerCase().trim() === addressData.address1.toLowerCase().trim() &&
                                       existing.city && existing.city.toLowerCase().trim() === addressData.city.toLowerCase().trim() &&
                                       existing.state && existing.state.toLowerCase().trim() === addressData.state.toLowerCase().trim() &&
                                       existing.zip && existing.zip.toString().trim() === addressData.pincode.toString().trim() &&
                                       existing.country && existing.country.toUpperCase().substring(0, 2) === countryCode;
                            });
                            
                            if (existingAddress && existingAddress.id && typeof existingAddress.id === 'number' && existingAddress.id < 1000000000000) {
                                // Address exists, update it
                                addressData.address_id = existingAddress.id;
                                return _this.updateAddressInBackend(addressData)
                                    .then((response) => {
                                        updatedCount++;
                                        return {
                                            ...address,
                                            id: existingAddress.id,
                                            country: countryCode
                                        };
                                    })
                                    .catch((err) => {
                                        console.error("Error updating address:", err);
                                        failedCount++;
                                        // Log error for this address with row number
                                        const errorMessage = (err.response && err.response.data && err.response.data.error) || err.error || err.message || "Error updating address";
                                        _this.bulkImportErrors.push({
                                            row: address.row || 'N/A',
                                            address: `${address.fullname || 'N/A'}, ${address.address_line1 || 'N/A'}, ${address.city || 'N/A'}, ${address.state || 'N/A'} ${address.zip || 'N/A'}`,
                                            error: errorMessage
                                        });
                                        return {
                                            ...address,
                                            id: existingAddress.id,
                                            country: countryCode
                                        };
                                    });
                            } else {
                                // New address, create it
                                return _this.createAddressInBackend(addressData)
                                    .then((response) => {
                                        if (response && response.data && response.data.address) {
                                            savedCount++;
                                            return {
                                                ...address,
                                                id: response.data.address.id,
                                                country: countryCode
                                            };
                                        }
                                        return {
                                            ...address,
                                            country: countryCode
                                        };
                                    })
                                    .catch((err) => {
                                        console.error("Error saving address:", err);
                                        failedCount++;
                                        // Log error for this address with row number
                                        const errorMessage = (err.response && err.response.data && err.response.data.error) || err.error || err.message || "Error saving address";
                                        _this.bulkImportErrors.push({
                                            row: address.row || 'N/A',
                                            address: `${address.fullname || 'N/A'}, ${address.address_line1 || 'N/A'}, ${address.city || 'N/A'}, ${address.state || 'N/A'} ${address.zip || 'N/A'}`,
                                            error: errorMessage
                                        });
                                        // Still add with temporary ID if API fails
                                        return {
                                            ...address,
                                            id: Date.now() + Math.random(),
                                            country: countryCode
                                        };
                                    });
                            }
                        });
                    
                        Promise.all(savePromises).then((savedAddresses) => {
                            // Filter out null addresses (failed validation)
                            const validAddresses = savedAddresses.filter(addr => addr !== null);
                            
                            // Remove duplicates from savedAddresses (in case same address was in CSV multiple times)
                            const uniqueAddresses = [];
                            const addressKeys = new Set();
                            
                            validAddresses.forEach((addr) => {
                                const key = `${addr.address_line1}_${addr.city}_${addr.state}_${addr.zip}_${addr.country}`.toLowerCase();
                                if (!addressKeys.has(key)) {
                                    addressKeys.add(key);
                                    uniqueAddresses.push(addr);
                                }
                            });
                            
                            // Merge with existing addresses, avoiding duplicates
                            const mergedAddresses = [...existingAddresses];
                            uniqueAddresses.forEach((newAddr) => {
                                const exists = mergedAddresses.find((existing) => {
                                    return existing.id === newAddr.id || (
                                        existing.address_line1 && existing.address_line1.toLowerCase().trim() === newAddr.address_line1.toLowerCase().trim() &&
                                        existing.city && existing.city.toLowerCase().trim() === newAddr.city.toLowerCase().trim() &&
                                        existing.state && existing.state.toLowerCase().trim() === newAddr.state.toLowerCase().trim() &&
                                        existing.zip && existing.zip.toString().trim() === newAddr.zip.toString().trim() &&
                                        existing.country && existing.country.toUpperCase().substring(0, 2) === (newAddr.country || 'US').toUpperCase().substring(0, 2)
                                    );
                                });
                                
                                if (!exists) {
                                    mergedAddresses.push(newAddr);
                                } else if (newAddr.id && typeof newAddr.id === 'number' && newAddr.id < 1000000000000) {
                                    // Update existing with new data
                                    const index = mergedAddresses.indexOf(exists);
                                    mergedAddresses[index] = { ...exists, ...newAddr };
                                }
                            });
                            
                            _this.splitAddresses = mergedAddresses;
                            // Ensure only one default after bulk upload
                            _this.ensureOnlyOneDefault();
                            _this.$store.commit("splitShipment/setSplitAddresses", _this.splitAddresses);
                            
                            // Build success message
                            let message = '';
                            if (updatedCount > 0 && savedCount > 0) {
                                message = `${savedCount} addresses added, ${updatedCount} addresses updated`;
                            } else if (updatedCount > 0) {
                                message = `${updatedCount} addresses updated`;
                            } else if (savedCount > 0) {
                                message = `${savedCount} addresses imported successfully`;
                            } else {
                                message = "No addresses were imported";
                            }
                            
                            // Set success message for modal
                            if (savedCount > 0 || updatedCount > 0) {
                                _this.bulkImportSuccessMessage = message;
                            }
                            
                            // Show toast notifications
                            const errorCount = _this.bulkImportErrors.filter(e => !e.warning).length;
                            const warningCount = _this.bulkImportErrors.filter(e => e.warning).length;
                            
                            if (errorCount > 0 || failedCount > 0) {
                                const totalFailed = errorCount + failedCount;
                                _this.$toast.warning(`${message}. ${totalFailed} address(es) failed.`, {
                                    position: "top-right",
                                    duration: 8000
                                });
                                // Auto-open error modal if there are errors
                                _this.$nextTick(() => {
                                    /* eslint-disable */
                                    $("#uploadAddressCSVErrors").modal("show");
                                    /* eslint-enable */
                                });
                            } else if (warningCount > 0) {
                                _this.$toast.warning(`${message}. ${warningCount} address(es) have suggestions.`, {
                                    position: "top-right",
                                    duration: 8000
                                });
                                // Auto-open error modal if there are warnings
                                _this.$nextTick(() => {
                                    /* eslint-disable */
                                    $("#uploadAddressCSVErrors").modal("show");
                                    /* eslint-enable */
                                });
                            } else {
                                _this.$toast.success(message, {
                                    position: "top-right"
                                });
                            }
                            
                            // Reset file input
                            _this.$refs.csvFileInput.value = "";
                            
                            // Hide loader after import completes
                            _this.isBulkImporting = false;
                        });
                    }).catch((err) => {
                        console.error("Error loading existing addresses:", err);
                        _this.isBulkImporting = false;
                        _this.$toast.error("Error loading existing addresses", {
                            position: "top-right"
                        });
                    });
                } catch (error) {
                    console.error("Error parsing CSV:", error);
                    this.isBulkImporting = false;
                    this.$toast.error("Error parsing CSV file. Please check the format.", {
                        position: "top-right"
                    });
                }
            };
            reader.readAsText(file);
        },
        goBack() {
            this.$emit("go-back");
        },
        validateAddressesBeforeProceed() {
            const invalidAddresses = [];

            this.splitAddresses.forEach((address, index) => {
                const missingFields = [];
                const email = (address.email || "").toString().trim();

                if (!email) {
                    missingFields.push("email");
                }

                if (missingFields.length > 0) {
                    invalidAddresses.push({
                        index: index + 1,
                        missingFields
                    });
                }
            });

            if (invalidAddresses.length > 0) {
                const firstInvalidAddress = invalidAddresses[0];
                const fieldsText = firstInvalidAddress.missingFields.join(" and ");
                this.$toast.error(`Address ${firstInvalidAddress.index} is missing ${fieldsText}`, {
                    position: "top-right",
                    duration: 5000
                });
                return false;
            }

            return true;
        },
        proceedToNext() {
            if (this.splitAddresses.length < 2) {
                this.$toast.error("Please add at least 2 addresses for split shipment", {
                    position: "top-right"
                });
                return;
            }

            // Ensure all addresses have required contact details before moving ahead
            if (!this.validateAddressesBeforeProceed()) {
                return;
            }
            
            // Ensure addresses are saved to Vuex before navigation
            console.log("[SplitShipmentAddressManager] proceedToNext - splitAddresses:", this.splitAddresses);
            console.log("[SplitShipmentAddressManager] proceedToNext - splitAddresses.length:", this.splitAddresses.length);
            
            // Save addresses to Vuex store
            this.$store.commit("splitShipment/setSplitAddresses", this.splitAddresses);
            
            // Verify addresses are saved
            const savedAddresses = this.$store.state.splitShipment && this.$store.state.splitShipment.splitAddresses;
            console.log("[SplitShipmentAddressManager] proceedToNext - savedAddresses in Vuex:", savedAddresses);
            console.log("[SplitShipmentAddressManager] proceedToNext - savedAddresses.length:", savedAddresses ? savedAddresses.length : 0);
            
            if (!savedAddresses || savedAddresses.length === 0) {
                console.error("[SplitShipmentAddressManager] Failed to save addresses to Vuex");
                this.$toast.error("Failed to save addresses. Please try again.", {
                    position: "top-right"
                });
                return;
            }
            
            // Emit proceed-next event
            this.$emit("proceed-next");
        }
    }
};
</script>

<style scoped>
.split-shipment-address-manager {
    padding: 20px 0;
    margin-bottom: 80px;
}

.split-shipment-address-manager .heading1 {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    color: #121212;
    margin-bottom: 24px !important;
}
.bulk-upload-section {
    border-bottom: 1px solid #BEBEBE66;
}
.split-shipment-address-manager .mb-4.text-muted {
    font-size: 14px;
    line-height: 20px;
    color: #6b6b6b !important;
    margin-bottom: 16px !important;
}
.form-group.label-const {
    position: relative;
    margin-top: 16px;
}



.form-group.label-const .form-control {
    padding: 10px 12px;
}

.form-group.label-const .highlight {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px;
    background-color: #1d6cb5;
    transition: width 0.3s;
}

.form-group.label-const .form-control:focus ~ .highlight {
    width: 100%;
}

.set-default-section {
    margin-top: 10px;
}

.set-default-text {
    margin-left: 8px;
    font-size: 14px;
    line-height: 14px;
    font-weight: 500;
    color: #121212;
    cursor: pointer;
}

.checkbox_custom {
    position: relative;
    display: inline-flex;
    cursor: pointer;
    padding-right: 28px;
    padding-left: 0px;
}

.checkbox_custom input[type="radio"] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    margin: 0;
}

.checkbox_custom .radio-mark {
    position: absolute;
    top: 0;
    left: inherit;
    right: 0px;
    height: 18px;
    width: 18px;
    background-color: #fff;
    border: 2px solid #B6B6B6;
    border-radius: 50%;
}

.checkbox_custom input[type="radio"]:checked ~ .radio-mark {
    background-color: #fff;
    border-color: #1D6CB5;
}

.checkbox_custom input[type="radio"]:checked ~ .radio-mark:after {
    content: "";
    position: absolute;
    display: block;
    top: 50% !important;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #1D6CB5;
}



.bulk-upload-link {
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    color: #1d6cb5 !important;
    text-decoration: none;
    cursor: pointer;
}

.bulk-upload-link svg {
    margin-right: 4px;
}

.bulk-upload-link:hover {
    text-decoration: underline;
}

.info-icon {
    width: 16px;
    height: 16px;
    display: block;
}

.bulk-info-popover-wrap {
    position: relative;
    display: inline-flex;
    align-items: center;
    padding-right: 10px;
    border-right: 1px solid #929292;
}

.bulk-info-popover-trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    line-height: 0;
}

.bulk-info-popover-trigger:focus {
    outline: 2px solid #1d6cb5;
    outline-offset: 2px;
}

.bulk-info-popover {
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    width: 280px;
    max-width: min(280px, calc(100vw - 32px));
    padding: 16px;
    background: #fff;
    border: 1px solid #cbc9c9;
    border-radius: 8px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
    z-index: 1050;
    text-align: left;
}

.bulk-info-popover__arrow {
    position: absolute;
    top: -6px;
    right: 12px;
    width: 10px;
    height: 10px;
    background: #fff;
    border-left: 1px solid #cbc9c9;
    border-top: 1px solid #cbc9c9;
    transform: rotate(45deg);
    box-sizing: border-box;
}

.bulk-info-popover__text {
    margin: 0 0 16px;
    font-size: 14px;
    line-height: 20px;
    color: #414141;
    font-weight: 400;
}

.bulk-info-popover__download {
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    text-decoration: underline;
    cursor: pointer;
}

.bulk-info-popover__download svg {
    margin-right: 6px;
    flex-shrink: 0;
}

.address-item {
    background-color: #fff;
    border-bottom: 1px solid #B6B6B6;
    padding-bottom: 8px;
    margin-bottom: 16px;
}


.form-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}

.split-shipment-address-manager .address-form-save-btn {
    min-width: 100px;
    height: 40px;
    padding: 10px 24px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
}

.navigation-buttons {
    padding-top: 20px;
    border-top: 1px solid #dee2e6;
}

.bg_primary_orange {
    background-color: #F2790C;
}

.text_white {
    color: #ffffff;
}

.split-shipment-address-manager .btn.bg_primary_orange.text_white {
    min-width: 130px;
    height: 40px;
    padding: 0 20px;
    border-radius: 4px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    border: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-family: 'mulish';
}

.select_option_label {
    font-weight: 700 !important;
    top: -13px !important;
    margin-top: 0px !important;
    position: relative;
    font-size: 14px;
    color: #000;
    margin-bottom: 10px;
}
.split-shipment-address-manager .white_box {
    padding: 24px 32px !important;
}
.select_option_label.bill_state {
    top: -22px !important;
}

.btn_outline_primary {
    background-color: transparent;
    border: 1px solid;
}

.border_primary_blue {
    border-color: #1d6cb5 !important;
    height: 40px;
    border-radius: 4px;
    border: 1px solid #1D6CB5;
    max-width: 120px;
    font-size: 16px;
    line-height: 20px;
    color: #1D6CB5;
    font-weight: 600;
    padding: 12px 25px;
    display: flex;
    justify-content: center;
    align-items: center;
}



.py_18 {
    padding-top: 18px;
    padding-bottom: 18px;
}

.px_32 {
    padding-left: 32px;
    padding-right: 32px;
}

.px_46 {
    padding-left: 46px;
    padding-right: 46px;
}

.px_64 {
    padding-left: 64px;
    padding-right: 64px;
}

.btn_orange {
    border: none;
}

/* Ensure v-select displays country name correctly */
.v-select .vs__selected {
    color: #333;
}

.v-select .vs__dropdown-toggle {
    border: 1px solid #33333380;
    padding: 8px 12px;
    min-height: 40px;
}

.v-select .vs__search::placeholder {
    color: #999;
}
.add_address{
    background-color: transparent;
    border: none;
    box-shadow: none;
    font-size: 14px;
    color: #1D6CB5;
    font-weight: 700;
}
.add_address_section h2{
    font-size: 20px;
    font-weight: 600;
    line-height: 20px;
    color: #121212;
    margin-bottom: 12px;
}
.add_address_section p{
    font-size: 14px;
    line-height: 16px;
    color: #414141;
    margin-bottom: 0px;
}
.add_address_section_wrapper{
    display: flex;
    justify-content: space-between;
}
.add_address_section_wrapper .add_address_section_buttons{
    display: flex;
    gap: 10px;
    align-items: center;
}
.address-form-section{
    border: 1px solid #B6B6B6;
    padding: 16px;
}
.shipping_payment_detail .white_box .address-form-section label{
    font-size: 14px;
    line-height: 14px;
    color: #333333;
    margin-bottom: 12px !important;
    font-weight: 500 !important;
    position: static;
}

.address-form-section h3{
    font-size: 14px;
    line-height: 14px;
    color: #121212;
    margin-bottom: 0px;
    font-weight: 700;
    padding-left: 0px;
}



.address-form-section textarea {
    resize: vertical;
}

.address-form-section .form-control:focus,
.address-form-section textarea:focus {
    border-color: #1D6CB5;
    box-shadow: 0 0 0 1px rgba(29, 108, 181, 0.2);
}

.address-form-section .v-select .vs__dropdown-toggle {
    border: 1px solid #D1D5DB;
    border-radius: 2px;
    min-height: 40px;
    padding: 6px 10px;
}

.address-form-section .v-select .vs__selected,
.address-form-section .v-select .vs__search {
    font-size: 14px;
    line-height: 20px;
    color: #121212;
}
.address-item .address_info{
    display: flex;
    align-items: center;
}
.address-item .address_info .address-text span{
    color: #414141;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    font-family: 'mulish';
}
.address-item .address_info p{
    color: #121212;
    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
    margin-bottom: 0px;
    font-family: 'mulish';
}
.address-item .address-actions{
    display: flex;
    gap: 16px;
    align-items: center;
}
.address-item .address-actions .edit_icon{
    background-color: transparent;
    border: none;
}
.address-item .badge-primary{
    color: #1D6CB5;
     font-weight: 600;
    font-size: 14px;
    line-height: 14px;
    background-color: #1D6CB51A;
    padding: 4px;
    border-radius: 4px;
}
.add_address_section_buttons .text_primary_blue {
    color: #1D6CB5 !important;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
}

@media (max-width: 991px) {
    .split-shipment-address-manager {
        padding: 12px 0;
        margin-bottom: 56px;
    }

    .split-shipment-address-manager .white_box {
        padding: 20px !important;
    }

    .add_address_section_wrapper {
        flex-direction: column;
        align-items: flex-start;
        gap: 14px;
    }

    .add_address_section_wrapper .add_address_section_buttons {
        width: 100%;
        flex-wrap: wrap;
        gap: 12px;
    }

    .split-shipment-address-manager .shipping-options-radio-group {
        gap: 12px;
    }

    .address-item .d-flex.justify-content-between {
        flex-direction: column;
        gap: 14px;
    }

    .address-item .address_info {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .address-item .address_info p {
        margin-bottom: 0;
    }

    .address-item .address-actions {
        width: 100%;
        flex-wrap: wrap;
        justify-content: flex-start;
        gap: 10px;
    }

    .address-form-section .row > [class*="col-"] {
        flex: 0 0 100%;
        max-width: 100%;
    }

    .add-address-btns {
        max-width: 100%;
        width: 100%;
    }
}

@media (max-width: 767px) {
    .split-shipment-address-manager .heading1 {
        font-size: 18px;
        line-height: 22px;
    }

    .add_address_section h2 {
        font-size: 18px;
        line-height: 20px;
    }

    .split-shipment-address-manager .shipping-options-radio-group {
        flex-direction: column;
        align-items: flex-start;
    }

    .add_address_section_wrapper .add_address_section_buttons .bulk-upload-link,
    .add_address_section_wrapper .add_address_section_buttons .add_address {
        width: 100%;
    }

    .add_address_section_wrapper .add_address_section_buttons .add_address {
        text-align: left;
        padding: 0;
    }

    .bulk-info-popover {
        right: auto;
        left: 0;
        width: min(280px, calc(100vw - 48px));
    }

    .bulk-info-popover__arrow {
        right: auto;
        left: 12px;
    }

    .address-item .address_info .address-text span,
    .address-item .address_info p {
        font-size: 14px;
        line-height: 20px;
    }
}

@media (max-width: 575px) {
    .split-shipment-address-manager .white_box {
        padding: 16px !important;
    }

    .address-form-section {
        padding: 12px;
    }

    .set-default-text {
        font-size: 13px;
        line-height: 16px;
    }
}
</style>

<style>
 .shipping_payment_detail .white_box   .address-form-section .form-control,
.shipping_payment_detail .white_box .address-form-section textarea.form-control,
.shipping_payment_detail .white_box .address-form-section .vs__search {
    border: 1px solid #33333380 !important;
    border-radius: 2px !important;
    padding: 8px 10px !important;
    min-height: 40px;
    font-size: 14px !important;
    line-height: 14px !important;
    color: #121212 !important;
    box-shadow: none;
    font-weight: 600 !important;
    font-family: 'mulish';
    height: 40px;
    margin-top: 0px;
}

.shipping_payment_detail .white_box .address-form-section .vs__search::placeholder {

    font-size: 14px !important;
    line-height: 14px !important;
    color: #121212 !important;
    font-weight: 500 !important;
    font-family: 'mulish' !important;
}
.shipping_payment_detail .white_box .address-form-section .vs__selected{
    margin: 0px;
    padding-left: 10px;
    top: 8px;
}
.shipping_payment_detail .white_box .address-form-section .form-group{
    margin-top: 16px;
}
section.shipping_payment_detail .white_box .address-form-section .vs__selected-options input{
    background-position: 95% 50% !important;
}
.add-address-btns{
    margin-left: auto;
    max-width: 270px;
}
.add-address-btns .btn{
    max-width: 140px;
}
.disclaimer {
    font-size: 12px;
    line-height: 12px;
    color: #414141;
    font-style: italic;
    margin-top: 16px;
    position: absolute;
    bottom: -10px;
}
.disclaimer p{
    font-size: 12px;
    line-height: 12px;
    color: #414141;
    font-style: italic;
    margin: 0px;
}
.shipping_payment_detail .split-shipment-address-manager .white_box .address-form-section label{
    font-weight: 600 !important;
    font-family: 'mulish';
}
.shipping_payment_detail .split-shipment-address-manager .shipping-options-radio-group {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
}
.shipping_payment_detail .split-shipment-address-manager .shipping-option-label {
    display: flex;
    align-items: center;
    cursor: pointer;
    gap: 8px;
}

@media (max-width: 991px) {
    .shipping_payment_detail .split-shipment-address-manager .add-address-btns {
        margin-left: 0;
        max-width: 100%;
        width: 100%;
    }

    .shipping_payment_detail .split-shipment-address-manager .add-address-btns .btn {
        max-width: none;
    }

    .shipping_payment_detail .split-shipment-address-manager .disclaimer {
        position: static;
        margin-top: 16px;
    }
}

@media (max-width: 767px) {
    .shipping_payment_detail .split-shipment-address-manager .add-address-btns {
        gap: 10px;
    }

    .shipping_payment_detail .split-shipment-address-manager .add-address-btns .btn {
        flex: 1 1 calc(50% - 5px);
        min-width: 0;
        width: auto;
    }
}
</style>
